import * as yup from 'yup';
import { InfoStatBlock } from '@web/components/InformationStats/InfoStatBlock';

export const component = InfoStatBlock;

export const schema = yup
  .object({
    heading: yup.string(),
    textColor: yup.string(),
    backgroundColor: yup.string(),
    description: yup.string(),
  })
  .transform(value => ({
    heading: value.heading,
    textColor: value.text_color,
    backgroundColor: value.background_color,
    description: value.description,
  }));
